import React from 'react';
import { PropTypes } from 'prop-types';
import classnames from 'classnames';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


const SuccessBadge = ({ size = 'md' }) => (
  <div className={classnames('success-badge', { 'badge-sm': size === 'sm' })}>
    <CheckCircleIcon fontSize="inherit" />
  </div>
);

SuccessBadge.propTypes = {
  size: PropTypes.string,
};


export default SuccessBadge;
